import { render, staticRenderFns } from "./MailFetchingManage.vue?vue&type=template&id=6a69bf42&scoped=true"
import script from "./MailFetchingManage.vue?vue&type=script&lang=js"
export * from "./MailFetchingManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69bf42",
  null
  
)

export default component.exports